export namespace Loader {
  export function showLoader(): void {
    document.body.classList.add('show-loader');
  }

  export function hideLoader(): void {
    document.body.classList.remove('show-loader');
  }

  export function toggleLoader(): void {
    const loaderShowing = document.body.classList.contains('show-loader');

    if (loaderShowing) {
      hideLoader();
    } else {
      showLoader();
    }
  }
}
